import { cn, Label, Tooltip, TooltipContent, TooltipTrigger } from '@planuze/ui';
import { Info } from 'lucide-react';
import type { ReactNode } from 'react';

/* Label com ícone de ajuda: encosta um gatilho de tooltip (ícone Info) ao lado do
   rótulo para explicar o EFEITO do campo. Acessível — o gatilho é um <button> focável
   por teclado, com aria-label próprio, e o Radix liga o texto do tooltip ao gatilho
   via aria-describedby (aparece no hover E no foco). */
export function LabelWithTooltip({
  htmlFor,
  tooltip,
  ariaLabel,
  className,
  children,
}: {
  readonly htmlFor?: string;
  /** Texto pt-BR curto explicando o efeito do campo. */
  readonly tooltip: string;
  /** Rótulo acessível do gatilho de ajuda (ex.: "Sobre Máx. findings"). */
  readonly ariaLabel: string;
  readonly className?: string;
  readonly children: ReactNode;
}) {
  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <Label htmlFor={htmlFor} className="text-foreground">
        {children}
      </Label>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={ariaLabel}
            className="text-muted-foreground hover:bg-accent/15 hover:text-foreground focus-visible:ring-ring inline-flex items-center justify-center rounded-sm p-0.5 focus-visible:outline-none focus-visible:ring-2"
          >
            <Info className="size-3.5" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-pretty">{tooltip}</TooltipContent>
      </Tooltip>
    </div>
  );
}
